import { SVGProps, Ref, forwardRef } from 'react';

export const EllipsisHorizontalCircleFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 12c0 5.5 2.75 11 11 11s11-5.5 11-11S20.25 1 12 1 1 6.5 1 12m15 0c0 1.125.75 1.5 1.5 1.5S19 13.125 19 12s-.75-1.5-1.5-1.5-1.5.375-1.5 1.5m-9.5 1.5c-.75 0-1.5-.375-1.5-1.5s.75-1.5 1.5-1.5S8 10.875 8 12s-.75 1.5-1.5 1.5m4-1.5c0 1.125.75 1.5 1.5 1.5s1.5-.375 1.5-1.5-.75-1.5-1.5-1.5-1.5.375-1.5 1.5"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
EllipsisHorizontalCircleFilledSize24Glyph.displayName = 'EllipsisHorizontalCircleFilledSize24Glyph';
